export default __webpack_public_path__ + "device_doorbell_pro_gen_2.e6f378cb.png";